import { createWebHistory, createRouter } from "vue-router";

// Tmkt3 Pages
import TmktLogin from '../login/login';

import TmktBody from '../components/tmkt/layout/body';
import Dashboard from '../pages/tmkt/dashboard';
import Employers from '../pages/tmkt/rrhh/employers';
import Employees from '../pages/tmkt/rrhh/employees';
import EmployeeContracts from '../pages/tmkt/rrhh/contracts';
import Employee from '../pages/tmkt/rrhh/employees/employee';
import Salaries from '../pages/tmkt/rrhh/salaries';
import TmktNotFound from '../pages/tmkt/not_found';

import EmployeePublicView from '../pages/tmkt/rrhh/employees/employee_public_view';

import TmktPublicBody from '../components/tmkt/layout/public_body';

const routes = [
    {
      path: '/empleados',
      component: TmktPublicBody,
      children: [
        {
          path: ':token/view',
          name: 'employee_public_view',
          component: EmployeePublicView,
          meta: {
            title: 'Tmkt3 | Expediente del Empleado',
          }
        },
        {
          path: ':token/:id/contract',
          name: 'employee_public_contract',
          component: EmployeePublicView,
          meta: {
            title: 'Tmkt3 | Expediente del Empleado',
          }
        }
      ]
    },
    {
        path: '/',
        component: TmktBody,
        children: [
          {
            path: '',
            name: 'defaultRoot',
            component: Dashboard,
            meta: {
              title: ' Cuba - Premium Admin Template',
            }
          },
          {
            path: 'panel/employers',
            name: 'employers',
            component: Employers,
            meta: {
              title: 'Tmkt3 | Patrones',
            }
          },
          {
            path: 'panel/employees',
            name: 'employees',
            component: Employees,
            meta: {
              title: 'Tmkt3 | Empleados',
            }
          },
          {
            path: 'panel/:id/employee',
            name: 'employee',
            component: Employee,
            meta: {
              title: 'Tmkt3 | Empleado',
            }
          },
          {
            path: 'panel/employees/contracts',
            name: 'employee_contracts',
            component: EmployeeContracts,
            meta: {
              title: 'Tmkt3 | Contractos',
            }
          },
          //Pendientes
          {
            path: 'panel/params',
            name: 'params',
            component: TmktNotFound,
            meta: {
              title: 'Tmkt3 | Parametros',
            }
          },
          {
            path: 'panel/users',
            name: 'users',
            component: TmktNotFound,
            meta: {
              title: 'Tmkt3 | Usuarios',
            }
          },
          {
            path: 'panel/roles',
            name: 'roles',
            component: TmktNotFound,
            meta: {
              title: 'Tmkt3 | Roles & Permisos',
            }
          },
          {
            path: 'panel/stores',
            name: 'stores',
            component: TmktNotFound,
            meta: {
              title: 'Tmkt3 | Tiendas',
            }
          },
          {
            path: 'panel/branchs',
            name: 'branchs',
            component: TmktNotFound,
            meta: {
              title: 'Tmkt3 | Sucursales',
            }
          },
          {
            path: 'panel/promotors',
            name: 'promotors',
            component: TmktNotFound,
            meta: {
              title: 'Tmkt3 | Promotores',
            }
          },
          {
            path: 'panel/managers',
            name: 'managers',
            component: TmktNotFound,
            meta: {
              title: 'Tmkt3 | Supervisores',
            }
          },
          {
            path: 'panel/kams',
            name: 'kams',
            component: TmktNotFound,
            meta: {
              title: 'Tmkt3 | Kams',
            }
          },
          {
            path: 'panel/customers',
            name: 'customers',
            component: TmktNotFound,
            meta: {
              title: 'Tmkt3 | Clientes',
            }
          },
          {
            path: 'panel/contracts',
            name: 'contracts',
            component: TmktNotFound,
            meta: {
              title: 'Tmkt3 | Contratos',
            }
          },
          {
            path: 'panel/visits',
            name: 'visits',
            component: TmktNotFound,
            meta: {
              title: 'Tmkt3 | Programación de Visitas',
            }
          },
          {
            path: 'panel/importer',
            name: 'importer',
            component: TmktNotFound,
            meta: {
              title: 'Tmkt3 | Importador de Visitas',
            }
          },
          {
            path: 'panel/monitor',
            name: 'monitor',
            component: TmktNotFound,
            meta: {
              title: 'Tmkt3 | Monitoreo de Visitas',
            }
          },
          {
            path: 'panel/salaries',
            name: 'salaries',
            component: Salaries,
            meta: {
              title: 'Tmkt3 | Sueldos y Salarios',
            }
          },
          {
            path: 'panel/payrolls',
            name: 'payrolls',
            component: TmktNotFound,
            meta: {
              title: 'Tmkt3 | Pagos y Dispersiones',
            }
          },
          {
            path: 'panel/charts',
            name: 'charts',
            component: TmktNotFound,
            meta: {
              title: 'Tmkt3 | Gráficas',
            }
          },
          {
            path: 'panel/reports',
            name: 'reports',
            component: TmktNotFound,
            meta: {
              title: 'Tmkt3 | Reportes de Visitas',
            }
          },
          {
            path: 'panel/image-reports',
            name: 'image_reports',
            component: TmktNotFound,
            meta: {
              title: 'Tmkt3 | Reportes de Evidencias',
            }
          },
        ]
    },
    {
      path: '/login',
      children: [
        {
          path: '',
          name: 'Login',
          component: TmktLogin,
          meta: {
            title: 'Tmkt3 | Inicio de Sesión',
          }
        }
      ]
    }
]
const router = createRouter({
    history: createWebHistory(),
    routes,
  })
  router.beforeEach((to, from, next) => {
    if(to.meta.title) document.title = to.meta.title;
    console.log(to.path);
    const  path = ['/login','/register','/empleados'];
     if(path.includes(to.path) || localStorage.getItem('User') || to.path.indexOf('/empleados/') != -1){
      return next();
     }
     next('/login');
});
  export default router